import { render, staticRenderFns } from "./viewPERIO.vue?vue&type=template&id=e6fcfa5e&scoped=true"
import script from "./viewPERIO.vue?vue&type=script&lang=js"
export * from "./viewPERIO.vue?vue&type=script&lang=js"
import style0 from "./viewPERIO.vue?vue&type=style&index=0&id=e6fcfa5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fcfa5e",
  null
  
)

export default component.exports